import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { STAGES } from 'config/teleconsultation';
import { formatDatetime } from 'helpers/timezone';
import { teleconsultationShape } from 'helpers/shared_types';

import { ReactComponent as CheckCircleSVG } from 'icons/table/check-circle.svg';
import { ReactComponent as ClockSVG } from 'icons/table/clock.svg';
import { ReactComponent as ExclamationSVG } from 'icons/table/exclamation.svg';
import { getHintFromPaymentStatus } from 'helpers/hint';

const TeleconsultationsCard = ({ data }) => {
  const history = useHistory();

  if (data.length === 0) return null;

  return (
    <div className="w-100 flex flex-column items-start justify-between">
      <div className="w-100">
        <section className="apps-grid-container th-active-users">
          <span className="apps-grid-title">Teleconsultations</span>
          <div className="apps-grid">
            {data.map((a) => {
              const isCancelled =
                a.cancelled ||
                [
                  'late-cancellation-by-patient',
                  'timely-cancellation-by-patient',
                  'cancelled-by-host',
                  'no-show',
                ].includes(a.status);

              const wrapperClasses = classnames('th-badge mr5', {
                'th-badge-green': a.currentPaymentStatus === 'succeeded',
                'th-badge-grey': a.currentPaymentStatus === 'incomplete',
                'th-badge-pink': a.currentPaymentStatus === 'failed',
              });
              const icon =
                a.currentPaymentStatus === 'succeeded' ? (
                  <CheckCircleSVG />
                ) : a.currentPaymentStatus === 'incomplete' ? (
                  <ClockSVG />
                ) : (
                  <ExclamationSVG />
                );

              return (
                <div key={a.id} className="apps-grid-cell pointer">
                  <article
                    className="apps-card-app"
                    onClick={() => history.push(`/teleconsultations/${a.id}`)}
                  >
                    <div className="apps-card-left">
                      <div className="apps-card-meta">
                        <h3 className="apps-card-app-title">
                          {isCancelled && (
                            <span role="img" aria-label="x" className="f-small">
                              &#10060;&nbsp;
                            </span>
                          )}
                          {a.doctor && a.doctor.lastName?.toUpperCase()}{' '}
                          {a.doctor && a.doctor.firstName}
                          {a.doctor ? ' - ' : ''}
                          {a.name}
                        </h3>

                        <p className="apps-card-app-desc">
                          {formatDatetime(a.startTime)}-{' '}
                          {formatDatetime(a.endTime)}
                        </p>

                        <p className="apps-card-app-desc">
                          Created at: {formatDatetime(a.createdAt)}
                        </p>
                      </div>
                    </div>
                    <div className="apps-card-right">
                      <div className="apps-configured">
                        {a.currentPaymentStatus && (
                          <span
                            className={wrapperClasses}
                            data-rh={
                              getHintFromPaymentStatus[a.currentPaymentStatus]
                            }
                          >
                            {icon}€{a.currentPaymentAmount}
                          </span>
                        )}
                        <span className="th-badge">
                          {STAGES.find((s) => s.id === a.stage).shortLabel}
                        </span>
                      </div>
                    </div>
                  </article>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
};

TeleconsultationsCard.propTypes = {
  data: PropTypes.arrayOf(teleconsultationShape),
};

export default TeleconsultationsCard;
